import { ColumnDef } from '@tanstack/react-table'

import { startCase } from '@hap/utils'
import { commafy } from '@hap/utils'

import { MakeColumnOptions } from './types'

export function NumberCell({
  value,
  precision,
}: {
  precision?: number
  value: number | string
}) {
  return <span className="whitespace-nowrap font-mono">{commafy(value, precision)}</span>
}

export function makeNumberColumnV2<D extends UnknownRecord>({
  fieldKey,
  header = startCase(fieldKey.toString()),
  sortable = true,
  width = 100,
  minWidth = width,
  maxWidth,
  precision = 0,
  onClick,
  footer,
}: Omit<MakeColumnOptions<D>, 'footer'> & {
  precision?: number
  footer?: string | number | null
}): ColumnDef<D> {
  return {
    accessorKey: fieldKey,
    id: fieldKey as string,
    cell: (cell) => <NumberCell value={cell.getValue<number>()} precision={precision} />,
    size: width,
    minSize: minWidth,
    maxSize: maxWidth,
    header,
    meta: {
      align: 'right',
      width,
      // @ts-ignore
      onClick,
    },
    footer: footer
      ? () => <NumberCell value={footer} precision={precision} />
      : undefined,
    enableSorting: sortable,
  }
}
